export default function removeDuplicates(array) {
  const foundIds = [];
  const dupesFiltered = array.filter((item) => {
    const duped = array.filter(i => i.id === item.id).length > 1;

    if (!duped) {
      return true;
    }

    if (foundIds.includes(item.id)) {
      return false;
    }
    foundIds.push(item.id);
    return true;
  });

  return dupesFiltered;
}
